import { createEvent, createStore } from 'effector'

import { startTypingToFanFx } from '@/models/chattingUI/pusher.ts'

export const startFanTyping = createEvent<number>('start fan typing ')
export const stopFanTyping = createEvent<number>('stop fan typing')
/**
 * Fans who typing to us now.
 */
export const $typingFans = createStore<
  Array<{ fanId: number; endsAt: number }>
>([])
  .on(startFanTyping, (store, fanId) => {
    return store
      .filter((item) => item.fanId !== fanId)
      .concat({
        fanId,
        endsAt: Date.now() + 5000,
      })
  })
  .on(stopFanTyping, (store, fanId) => {
    return store.filter((item) => item.fanId !== fanId)
  })

export const $typingFanIds = $typingFans.map((data) =>
  data.map(({ fanId }) => fanId),
)

/**
 * Check every second how much fans typing.
 */
window.setInterval(() => {
  // eslint-disable-next-line effector/no-getState
  $typingFans
    .getState()
    .filter((item) => item.endsAt < Date.now())
    .forEach(({ fanId }) => stopFanTyping(fanId))
}, 1000)

export const startChatterTyping = createEvent<number>('start typing to fan')
export const stopChatterTyping = createEvent<number>('stop typing to fan')
/**
 * Fans to whom we are typing (for AICH).
 */
export const $typingToChatters = createStore<Record<number, number>>([])
  .on(startChatterTyping, (store, fanId) => {
    if (store[fanId]) {
      return store
    } else {
      // trigger immedeately
      startTypingToFanFx(fanId)

      const intervalId = window.setInterval(() => {
         startTypingToFanFx(fanId)
      }, 3000)

      return {
        ...store,
        [fanId]: intervalId,
      }
    }
  })
  .on(stopChatterTyping, (store, fanId) => {
    if (store[fanId]) {
      window.clearInterval(store[fanId])
      delete store[fanId]

      return {
        ...store,
      }
    } else {
      return store
    }
  })
